<span class="button__busy">
  <span class="bounce1"></span>
  <span class="bounce2"></span>
</span>
@if (icon) {
  <span class="icon"
  [ngClass]="'icon-' + icon"></span>
}
<!-- <span class="icon icon-success button__success"></span>
<span class="icon icon-failure button__error"></span> -->
<span class="button__body">
  <ng-content></ng-content>
</span>